<div class="comment-form-container">
  <div class="comment-editor">
    <!-- Rich Text Editor Toolbar -->
    <div class="editor-toolbar" [class.disabled]="isSubmitting">
      <button
        type="button"
        class="toolbar-btn"
        (click)="execCommand('bold')"
        [disabled]="isSubmitting"
        title="Bold (Ctrl+B)"
      >
        <strong>B</strong>
      </button>
      <button
        type="button"
        class="toolbar-btn"
        (click)="execCommand('italic')"
        [disabled]="isSubmitting"
        title="Italic (Ctrl+I)"
      >
        <em>I</em>
      </button>
      <button
        type="button"
        class="toolbar-btn"
        (click)="execCommand('underline')"
        [disabled]="isSubmitting"
        title="Underline (Ctrl+U)"
      >
        <u>U</u>
      </button>
      <div class="toolbar-separator"></div>
      <button
        type="button"
        class="toolbar-btn"
        (click)="execCommand('insertUnorderedList')"
        [disabled]="isSubmitting"
        title="Bullet List"
      >
        ☰
      </button>
      <button
        type="button"
        class="toolbar-btn"
        (click)="execCommand('insertOrderedList')"
        [disabled]="isSubmitting"
        title="Numbered List"
      >
        ≡
      </button>
      <div class="toolbar-separator"></div>
      <button
        type="button"
        class="toolbar-btn"
        (click)="execCommand('formatBlock', 'blockquote')"
        [disabled]="isSubmitting"
        title="Quote"
      >
        "
      </button>
    </div>

    <!-- Rich Text Editor Area -->
    <div
      #editor
      class="rich-text-editor"
      contenteditable="true"
      [attr.contenteditable]="!isSubmitting"
      placeholder="Write your comment here..."
      (input)="onEditorInput()"
    ></div>

    <div class="comment-actions">
      <button
        type="button"
        class="cancel-button"
        (click)="onCancel()"
        [disabled]="isSubmitting"
      >
        Cancel
      </button>
      <button
        type="submit"
        class="submit-button"
        (click)="onSubmit()"
        [disabled]="!isValid || isSubmitting"
      >
        {{ isSubmitting ? "Posting..." : "Post Comment" }}
      </button>
    </div>
  </div>
</div>
